// extracted by mini-css-extract-plugin
module.exports = {"nextStepWrap":"hd_On","nextStep":"_1bBZd","stepWrapper":"_3Wiky","stepCount":"_1AVFY","stepHead":"_7_U3j","stepDetail":"CxqD1","stepimg":"OQPnt","steptext":"_1zCIA"};